import ProgressBlockHeader, {
    IProgressBlockHeader
} from './progress-block-header.component';

export default ProgressBlockHeader;
export { IProgressBlockHeader };
